export const SIGNAL_FONT_VARIANT = 'SIGNAL_FONT_VARIANT/'
